module.exports = __webpack_public_path__ + "static/img/xqhz_11.81153e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xqhz/xqhz_11.png
// module id = aWcl
// module chunks = 180